import { message } from 'antd';

// Shows the reconnect-aware error message for Square API failures. Returns
// true when the error was a reconnect-required error, so callers that track
// their own "needs reconnect" banner state can react to it.
const squareErrorToast = (err) => {
  const data = err?.response?.data;
  // The backend returns 422 for two unrelated cases:
  //  - IntegrationReconnectRequiredException -> JSON object { StatusCode, Message }
  //    with a Message that mentions "reconnect" (see
  //    Thisway.Service/Helpers/IntegrationReconnectRequiredException.cs).
  //  - Controller permission failures -> a plain JSON string
  //    ("User role / permission required").
  // Only the former should trigger the "reconnect Square" warning.
  const isReconnectError =
    err?.response?.status === 422 &&
    data &&
    typeof data === 'object' &&
    typeof data.Message === 'string' &&
    data.Message.toLowerCase().includes('reconnect');

  if (isReconnectError) {
    message.error(
      'Square connection needs to be re-authorized. Please disconnect and connect again to grant menu access.'
    );
  } else {
    message.error(data?.Message || data || err?.message || 'Request failed');
  }

  return isReconnectError;
};

export default squareErrorToast;
